import { createStore, del, get, set } from 'idb-keyval'

const dbStore = createStore('terminusDB', 'jotaiStore')

const STORAGE_VERSION = 1

interface StoredValue<T> {
  version: number
  data: T
}

// export interface AsyncStorage<Value> {
//   getItem: (key: string, initialValue: Value) => PromiseLike<Value>;
//   setItem: (key: string, newValue: Value) => PromiseLike<void>;
//   removeItem: (key: string) => PromiseLike<void>;
//   // subscribe?: Subscribe<Value>;
// }

function createIndexedDBStorage<T>() {
  return {
    async getItem(key: string, initialValue: T): Promise<T | null> {
      // console.log('initialValue', initialValue)
      try {
        const item = await get<StoredValue<T>>(key, dbStore)
        if (!item) return initialValue
        if (item.version !== STORAGE_VERSION) {
          // console.warn(`[jotai-db] Version mismatch for key "${key}". Resetting.`)
          await del(key, dbStore)
          return initialValue
        }
        return item.data
      } catch (error) {
        console.error(`[jotai-db] Failed to get key "${key}":`, error)
        return initialValue
      }
    },
    async setItem(key: string, value: T) {
      try {
        const item: StoredValue<T> = {
          version: STORAGE_VERSION,
          data: value,
        }
        await set(key, item, dbStore)
      } catch (error) {
        console.error(`[jotai-db] Failed to set key "${key}":`, error)
      }
    },
    async removeItem(key: string) {
      try {
        await del(key, dbStore)
      } catch (error) {
        console.error(`[jotai-db] Failed to remove key "${key}":`, error)
      }
    },
  } as T
}

export { 
  createIndexedDBStorage 
}
